module.exports = __webpack_public_path__ + "img/img11.c3a705c6.svg";